<template>
  <p>
    Após o pagamento da entrada, entre em contato com a empresa parceira para acompanhar o restante
    da negociação.
  </p>
</template>
